import { useState } from 'react';
import { useChatStore } from '../../stores/useChatStore.js';
import { usePluginRegistry } from '../../hooks/usePluginRegistry.js';
import { ChevronDownIcon } from 'lucide-react';

export function RecentTasksDropdown() {
  const { sessionId } = useChatStore();
  const { sessionThreads } = usePluginRegistry();
  const [open, setOpen] = useState(false);
  
  if (typeof window === 'undefined') return null;

  return (
    <div className="relative inline-block text-left w-full">
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center justify-between w-full px-3 py-2 bg-gray-800 rounded-lg shadow hover:bg-gray-700 transition-colors duration-200"
      >
        <span className="text-gray-200 text-sm truncate">
          {sessionThreads.find(s => s.id === sessionId)?.name || 'Recent Tasks'}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div
          className="
            absolute left-0 mt-1 w-full max-h-60
            bg-gray-900 rounded-lg shadow-lg
            ring-1 ring-black ring-opacity-20
            overflow-y-auto z-50
          "
        >
          {sessionThreads.map(s => (
            <div
              key={s.id}
              onDoubleClick={() => {
                s.onClick();
                setOpen(false);
              }}
              className={`
                px-3 py-2 cursor-pointer flex items-center justify-between
                ${s.id === sessionId ? 'bg-gray-800' : 'hover:bg-gray-800'}
                transition-colors duration-150
                first:rounded-t-lg last:rounded-b-lg
              `}
            >
              <div className="flex items-center space-x-2 flex-1 min-w-0">
                <div 
                  className={`w-2 h-2 rounded-full flex-shrink-0 ${
                    s.status === 'active' ? 'bg-emerald-500' :
                    s.status === 'idle' ? 'bg-amber-500' :
                    s.status === 'completed' ? 'bg-blue-500' :
                    'bg-red-500'
                  }`}
                />
                <span className="text-sm text-gray-200 truncate">{s.name}</span>
              </div>
              {s.id === sessionId && (
                <span className="text-xs text-gray-400 ml-2 flex-shrink-0">current</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default RecentTasksDropdown;
